import { Construction } from 'lucide-react';

export default function SectionPlaceholder({ sectionName }) {
  return (
    <section
      aria-labelledby="section-title"
      className="border border-gray-800 bg-[#161b22] p-6 shadow-2xl sm:p-8"
    >
      <div className="max-w-xl border-l-2 border-green-500 pl-5">
        <Construction aria-hidden="true" size={22} className="mb-5 text-green-900" />
        <p className="mb-2 font-mono text-[10px] font-bold uppercase tracking-[0.28em] text-green-500">
          Módulo operacional
        </p>
        <h2 id="section-title" className="text-xl font-black uppercase tracking-wide text-white sm:text-2xl">
          {sectionName}
        </h2>
        <p className="mt-4 text-sm leading-6 text-gray-400">
          Esta área está pronta para receber os indicadores e controles de {sectionName.toLowerCase()}.
        </p>
        
      </div>
    </section>
  );
}
